// @flow
import React from 'react';
import injectSheet from 'react-jss';

type Props = {
  classes: Object,
  x1: Number,
  y1: Number,
  x2: Number,
  y2: Number,
  x: Number,
  y: Number,
  fixed: Boolean
};


function FloatHeart({ classes: c }: Props) {
  return (
    <span className={c.container} />
  );
}

const styles = {
  container: {
    opacity: 0,
    position: 'fixed',
    height: '18px',
    width: '18px',
    borderRadius: '50%',
    background: '#d10000 url("https://genesis-cdn.ff.com/assets/widgetImages/icon_like_12_light.png") center center no-repeat',
    backgroundSize: '10px',
    display: 'block',
    animation: `$floatheart 3s ease-out`,
    pointerEvents: 'none',
    '--x1': ({ x1 }) => `${x1}px`,
    '--y1': ({ y1 }) => `${y1}px`,
    '--x2': ({ x2 }) => `${x2}px`,
    '--y2': ({ y2 }) => `${y2}px`,
    left: ({ fixed, x }) => fixed ? `${x}px` : 'inherit',
    top: ({ fixed, y }) => fixed ? `${y}px` : 'inherit'
  },
  '@keyframes floatheart': {
    '0%': {
      opacity: 0
    },
    '1%': {
      opacity: 0,
      transform: `translate(var(--x1),var(--y1))`
    },
    '2%': {
      opacity: 1,
      transform: `translate(var(--x1),var(--y1))`
    },
    '80%': {
      opacity: 1,
      transform: `translate(var(--x2),var(--y2))`
    },
    '100%': {
      opacity: 0,
      transform: `translate(var(--x2),var(--y2))`
    }
  }
};

export default injectSheet(styles)(FloatHeart);
